import React from 'react'
import MaterialSymbol from '../material-symbol'

const BarChart = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="bar_chart" {...props} />
))

BarChart.displayName = 'BarChart'

export default BarChart
